var React = require('react');

function Call (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M17.475 12.471c-1.163 0-2.305-.182-3.387-.54-.53-.18-1.183-.014-1.506.318l-2.137 1.613c-2.477-1.323-4.003-2.848-5.308-5.307l1.565-2.08c.407-.407.553-1 .378-1.557a10.804 10.804 0 01-.542-3.393C6.538.684 5.855 0 5.014 0h-3.49C.685 0 0 .684 0 1.525 0 11.16 7.84 19 17.475 19c.841 0 1.525-.684 1.525-1.525v-3.48c0-.84-.684-1.524-1.525-1.524z","fill":"#fff"}));
}

Call.defaultProps = {"width":"19","height":"19","viewBox":"0 0 19 19","fill":"none"};

module.exports = Call;

Call.default = Call;
